import { useContext } from "react";
import { Context } from "../../utils/main-context/MainContext";

import "./projects.scss";

import ProjectsBox from "../../components/projects/projects-box/Index";

const Projects = () => {
  const { projectsActive } = useContext(Context);

  return (
    <section
      id="projects"
      className={projectsActive ? "projects active" : "projects"}
    >
      <div className="container">
        <ProjectsBox />
      </div>
    </section>
  );
};

export default Projects;
